/*
 * CHO CRO N.2 / N.7 - tabbed mobile navigation drawer.
 * Progressive enhancement: markup renders as static panels; this element
 * adds tab switching, roving focus, and arrow-key navigation.
 */
if (!customElements.get('menu-drawer-tabs')) {
  customElements.define(
    'menu-drawer-tabs',
    class MenuDrawerTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        if (!this.tabs.length) return;
        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.activate(tab));
          tab.addEventListener('keydown', (event) => this.onKeydown(event));
        });
      }

      activate(tab) {
        this.tabs.forEach((current) => {
          const selected = current === tab;
          current.setAttribute('aria-selected', selected ? 'true' : 'false');
          current.setAttribute('tabindex', selected ? '0' : '-1');
        });
        this.panels.forEach((panel) => {
          panel.hidden = panel.getAttribute('aria-labelledby') !== tab.id;
        });
      }

      onKeydown(event) {
        const index = this.tabs.indexOf(document.activeElement);
        if (index === -1) return;
        let next = null;
        switch (event.key) {
          case 'ArrowRight':
          case 'ArrowDown':
            next = (index + 1) % this.tabs.length;
            break;
          case 'ArrowLeft':
          case 'ArrowUp':
            next = (index - 1 + this.tabs.length) % this.tabs.length;
            break;
          case 'Home':
            next = 0;
            break;
          case 'End':
            next = this.tabs.length - 1;
            break;
          default:
            return;
        }
        event.preventDefault();
        this.tabs[next].focus();
        this.activate(this.tabs[next]);
      }
    }
  );
}
